import { Radio, RadioChangeEvent } from 'antd';
import classNames from 'classnames/bind';
import React from 'react';
import { IRadioProps } from './entities';

const BCRadio: React.FC<IRadioProps> = props => {
	const onSelectedChanged = (e: RadioChangeEvent) => {
		props.onSelectedChange?.(e.target.value);
	};

	const classname = classNames({
		[props.className]: !!props.className
	});

	return (
		<Radio
			key={props.key}
			className={classname}
			style={props.style}
			checked={props.selected}
			value={props.value}
			disabled={props.disabled}
			tabIndex={props.tabIndex}
			name={props.groupName}
			onChange={onSelectedChanged}
		>
			{props.text}
		</Radio>
	);
};

export default BCRadio;
